import React from 'react';
import { cn } from '@/lib/utils';

interface SkipNavigationProps {
  links?: Array<{
    href: string;
    text: string;
  }>;
  className?: string;
}

export function SkipNavigation({ 
  links = [
    { href: '#main-content', text: 'Skip to main content' },
    { href: '#navigation', text: 'Skip to navigation' },
    { href: '#search', text: 'Skip to search' }
  ],
  className 
}: SkipNavigationProps) {
  return (
    <nav 
      className={cn(
        'sr-only focus-within:not-sr-only fixed top-0 left-0 z-50 bg-white border-b shadow-lg',
        className
      )}
      aria-label="Skip navigation"
    >
      <ul className="flex gap-2 p-4">
        {links.map((link, index) => (
          <li key={index}>
            <a
              href={link.href}
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}